import React from "react";
import styled from "styled-components";
import { Button, Row } from "reactstrap";
import FormByCostType from "./FormByCostType";
import PropTypes from "prop-types";


const PaymentType = ({ cost_data, type, events, offer, offer_data, isFormSubmit = false, isLoading = false, countries }) => {

  const generateKey = () => Math.round(Math.random() * 10000).toString();

  const [groups, setGroups] = React.useState((cost_data && cost_data?.length > 0) ? cost_data.map(i => ({
    ...i,
    key: generateKey(),
    suffix: generateKey()
  })) : [{ key: generateKey(), suffix: generateKey(), countries: [] }]);

  const handleAddGroup = () => {
    setGroups(prev => [...prev, { accordion_status: true, key: generateKey(),  suffix: generateKey(), countries: [] }]);
  };

  const handleDeleteGroup = key => {
    setGroups(prev => prev.filter(i => i.key !== key));
  };

  const handleChangeCountries = (val, key) => {
    setGroups(prev => prev.map(i =>
      i.key !== key
        ? i
        : ({
          ...i,
          countries: val
        })
    ));
  };

  const getFilteredCountries = (current_countries) => {
    let c = []
    groups.forEach(i => {
      c = c.concat(i.countries)
    })
    c = c.map(i => typeof i === "string" ? i : i.value)
    c = countries?.filter(i => !c.some(v => v === i.value)) || []
    const current_parsed = current_countries.map(i => {
      if (typeof i !== "string") return i;
      return countries.find(el => el.value === i) || {value: i, label: i}
    })
    return [...c, ...current_parsed];
  };

  return (
    <>
      {type && <PaymentTypeStyled>
        {groups.map((i) => <FormByCostType
          offer={offer}
          key={i.key}
          type={type}
          isLoading={isLoading}
          offer_data={offer_data}
          isFormSubmit={isFormSubmit}
          setGroups={setGroups}
          events={events}
          cost={i}
          accordion_status={i?.accordion_status}
          suffix={`|${i.suffix}|`}
          onDelete={groups.length > 1 ? () => handleDeleteGroup(i.key) : null}
          // countries={getFilteredCountries()}
          countries={getFilteredCountries(i.countries)}
          onChangeCountries={val => handleChangeCountries(val, i.key)}
        />)}
        <Row>
          <div className="text-start mt-3">
            <Button color="success" onClick={handleAddGroup}>Add countries group</Button>
          </div>
        </Row>
      </PaymentTypeStyled>}
    </>
  );
};

PaymentType.propTypes = {
  type: PropTypes.string,
  events: PropTypes.any,
  isFormSubmit: PropTypes.bool,
  isLoading: PropTypes.bool,
  offer_data: PropTypes.any,
  offer: PropTypes.any,
  cost_data: PropTypes.any,
  countries: PropTypes.array
};

const PaymentTypeStyled = styled.div`
`;

export default (PaymentType);
